export default __webpack_public_path__ + "static/media/cx_cover_jcs2.9a9998cc.jpg";